import { apiService } from './api';

export type CouponType = 'PERCENT' | 'FLAT';

export interface Coupon {
  id: string;
  code: string;
  description?: string;
  type: CouponType;
  value: number;
  minOrderAmount?: number;
  maxDiscount?: number;
  validFrom?: string;
  validTo?: string;
  usageLimit?: number;
  usedCount?: number;
  active: boolean;
  organizationCode: string;
  restaurantId?: string;
}

export interface CreateCouponRequest {
  code: string;
  description?: string;
  type: CouponType;
  value: number;
  minOrderAmount?: number;
  maxDiscount?: number;
  validFrom?: string;
  validTo?: string;
  usageLimit?: number;
  organizationCode: string;
  restaurantId?: string;
}

export interface CouponValidationResult {
  valid: boolean;
  code: string;
  discount: number;
  message: string;
}

export const couponService = {
  async list(org: string, restaurantId?: string, active?: boolean): Promise<Coupon[]> {
    const response = await apiService.get<Coupon[]>('/coupons', {
      org,
      ...(restaurantId && { restaurantId }),
      ...(active !== undefined && { active }),
    });
    return response.data;
  },

  async create(data: CreateCouponRequest): Promise<Coupon> {
    const response = await apiService.post<Coupon>('/coupons', data);
    return response.data;
  },

  async update(id: string, data: Partial<CreateCouponRequest>): Promise<Coupon> {
    const response = await apiService.put<Coupon>(`/coupons/${id}`, data);
    return response.data;
  },

  async toggleActive(id: string): Promise<Coupon> {
    const response = await apiService.patch<Coupon>(`/coupons/${id}/active`);
    return response.data;
  },

  async remove(id: string): Promise<void> {
    await apiService.delete(`/coupons/${id}`);
  },

  async validate(org: string, restaurantId: string | undefined, code: string, subTotal: number): Promise<CouponValidationResult> {
    const response = await apiService.get<CouponValidationResult>('/coupons/validate', {
      org, ...(restaurantId && { restaurantId }), code, subTotal,
    });
    return response.data;
  },
};
